import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { syncLanguageToPath } from '../i18n';

/**
 * Keeps the active language in step with the URL.
 *
 * The language detector runs once, at init, so it only sees the URL the
 * browser landed on. Navigating from '/terms' to '/ar/terms' through the
 * router changes no document — without this the page would stay in English at
 * an Arabic address, which is exactly what a crawler following the hreflang
 * link would record.
 *
 * Renders nothing; it exists for the effect. Mounted inside the Router in App
 * so it sees every navigation.
 */
export default function LanguageRouteSync() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Deliberately not awaited and not persisted: a URL-derived language
    // applies to this page, it is not a preference (see syncLanguageToPath).
    syncLanguageToPath(pathname);
  }, [pathname]);

  return null;
}
